/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
import './DraggableConnectionTable.scss';

import { CSSProperties } from 'react';
import {
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  flexRender,
  Row} from '@tanstack/react-table';
import { ApiConnection } from 'models/ApiConnection';

const RowDragHandleCell = ({ rowId }: { rowId: string }) => {
  const { attributes, listeners } = useSortable({
    id: rowId,
  })
  return (
    // Alternatively, you could set these attributes on the rows themselves
    <button type="button" {...attributes} {...listeners} className='btn btn-default' title='Reorder'>
      <i className='bi bi-grid-3x2-gap-fill' />
    </button>
  )
}

const DraggableRow = ({ row }: { row: Row<ApiConnection> }) => {
  const { transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id as any,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform), // let dnd-kit do its thing
    transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 1 : 0,
    position: 'relative',
  }

  return (
    // connect row ref to dnd-kit, apply important styles
    <tr ref={setNodeRef} style={style}>
      {row.getVisibleCells().map(cell => (
        <td key={cell.id} style={{ width: cell.column.getSize() }}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  )
};

export { DraggableRow, RowDragHandleCell };

